import { Radio } from '../Radio';

interface RadioGroupItemProps {
  label: string;
  selectedLabel: string;
  onRadioClick: (activeKey: string) => void;
  id: string;
}

export const RadioGroupItem = ({ label, selectedLabel, onRadioClick, id }: RadioGroupItemProps) => {
  const handleOnClick = () => {
    onRadioClick(label);
  };

  return <Radio onClick={handleOnClick} isActive={label === selectedLabel} label={label} id={id} />;
};
